import { Injectable } from '@angular/core';
import { User } from 'src/app/shared/models/security/user';
import { LogService } from '../log/log.service';
import {
	AREA_ACTIVE,
	OPTIM_MULTIPLE,
	OPTIM_QUEUE,
	PARAM_FUNDER_ACTIVE,
	PARAM_IS_AVAILABILITY_PLANNING_VISIBLE,
	PARAM_LABEL_HOUR_MAX_DAY,
	PARAM_LABEL_HOUR_MIN_DAY,
	PARAM_OPTIM_PARAMS_EDITABLE,
	PARAM_PREFERENCES_BENEFICIAIRE,
	PARAM_VEHICULE,
	PARAM_VEHICULE_VALUE_OFF
} from '../constant/constants.service';
import { Authority } from 'src/app/shared/models/security/authority';
import { OptimNotification } from 'src/app/shared/models/optim-notification';
import { ServiceCenter } from 'src/app/shared/models/service-center';
import { Service } from 'src/app/shared/models/service';
import { Region } from 'src/app/shared/models/region';

@Injectable({
	providedIn: 'root'
})
export class DataStorageService {
	JWT_TOKEN_KEY = 'JWT_TOKEN';
	TOKEN_ISY = 'TOKEN_ISY';
	REFRESH_TOKEN = 'REFRESH_TOKEN';
	USER = 'USER';
	OLD_USER = 'OLD_USER';
	SERVICE = 'SERVICE';
	REGION = 'REGION';
	NOTIFICATION_REFRESH_RATE_KEY = 'NOTIFICATION_REFRESH_RATE';

	constructor(private logger: LogService) {}

	getJwtToken(): string {
		return sessionStorage.getItem(this.JWT_TOKEN_KEY);
	}

	getTokenIsy(): string {
		return sessionStorage.getItem(this.TOKEN_ISY);
	}

	setJwtToken(token: string) {
		try {
			sessionStorage.setItem(this.JWT_TOKEN_KEY, token);
		} catch (e) {
			this.logger.log(
				'Impossible de sauvegarder le token JWT en local storage',
				e
			);
		}
	}

	setTokenIsy(tokenIsy: string) {
		try {
			sessionStorage.setItem(this.TOKEN_ISY, tokenIsy);
		} catch (e) {
			this.logger.log(
				'Impossible de sauvegarder le token isyplanning en local storage',
				e
			);
		}
	}

	getRefreshToken(): string {
		return sessionStorage.getItem(this.REFRESH_TOKEN);
	}

	setRefreshToken(token: string) {
		try {
			sessionStorage.setItem(this.REFRESH_TOKEN, token);
		} catch (e) {
			this.logger.log(
				'Impossible de sauvegarder le refresh token en local storage',
				e
			);
		}
	}

	isPlanificatrice(): boolean {
		const user: User = this.getUser();
		if (user?.profile?.id === Authority.PLANIFICATEUR) {
			return true;
		} else {
			return false;
		}
	}

	isProjectManager(): boolean {
		const user: User = this.getUser();
		if (user?.profile?.id === Authority.CHARGE_MISSION) {
			return true;
		} else {
			return false;
		}
	}

	isIntervenant(): boolean {
		const user: User = this.getUser();
		if (user?.typeUser === "Intervenant") {
			return true;
		} else {
			return false;
		}
	}

	isAssistant(): boolean {
		const user: User = this.getUser();
		if (user?.profile?.name === "Assistant") {
			return true;
		} else {
			return false;
		}
	}

	isAdmin(): boolean {
		const user: User = this.getUser();
		if (user?.profile?.name === "Admin") {
			return true;
		} else {
			return false;
		}
	}

	isManager(): boolean {
		const user: User = this.getUser();
		if (user?.profile?.name === "Manager") {
			return true;
		} else {
			return false;
		}
	}

	setService(service: Service): void {
		sessionStorage.setItem(this.SERVICE, service ? JSON.stringify(service) : '');
	}

	getService(): Service {
		return sessionStorage.getItem(this.SERVICE) ? JSON.parse(sessionStorage.getItem(this.SERVICE)) : null;
	}

	setRegion(region: Region): void {
		sessionStorage.setItem(this.REGION, region ? JSON.stringify(region) : '');
	}

	getRegion(): Region {
		return sessionStorage.getItem(this.REGION) ? JSON.parse(sessionStorage.getItem(this.REGION)) : null;
	}

	setUser(user: User): void {
		sessionStorage.setItem(this.USER, user ? JSON.stringify(user) : '');
	}

	getUser(): User {
		return JSON.parse(sessionStorage.getItem(this.USER));
	}

	setOldUser(user: User): void {
		sessionStorage.setItem(this.OLD_USER, user ? JSON.stringify(user) : '');
	}

	getOldUser(): User {
		return JSON.parse(sessionStorage.getItem(this.OLD_USER));
	}

	clearStorage() {
		localStorage.clear();
		sessionStorage.clear();
	}

	setParam(paramName: string, paramValue: any): void {
		sessionStorage.setItem(paramName, JSON.stringify(paramValue));
	}

	getParam(param: string): any {
		return JSON.parse(sessionStorage.getItem(param));
	}

	deleteParam(param: string) {
		sessionStorage.removeItem(param);
	}

	clearSession(): void {
		sessionStorage.clear();
	}

	getParamVehicule(): string {
		return JSON.parse(sessionStorage.getItem(PARAM_VEHICULE));
	}

	getOptimQueue(): OptimNotification[] {
		return JSON.parse(sessionStorage.getItem(OPTIM_QUEUE));
	}

	setOptimQueue(optimNotifs: OptimNotification[]) {
		sessionStorage.setItem(OPTIM_QUEUE, JSON.stringify(optimNotifs));
	}

	isVehiculeActive(): boolean {
		return JSON.parse(sessionStorage.getItem(PARAM_VEHICULE)) !==
			PARAM_VEHICULE_VALUE_OFF
			? true
			: false;
	}

	isFunderActive(): boolean {
		return JSON.parse(sessionStorage.getItem(PARAM_FUNDER_ACTIVE)) === 'true'
			? true
			: false;
	}

	isOptimParamsEditable(): boolean {
		return JSON.parse(sessionStorage.getItem(PARAM_OPTIM_PARAMS_EDITABLE)) ===
			'true'
			? true
			: false;
	}

	isAreaActive(): boolean {
		return JSON.parse(sessionStorage.getItem(AREA_ACTIVE)) === 'true'
			? true
			: false;
	}

	isOptimMultipleActive(): boolean {
		return JSON.parse(sessionStorage.getItem(OPTIM_MULTIPLE)) === 'true'
			? true
			: false;
	}

	getParamMinDay(): number {
		return JSON.parse(sessionStorage.getItem(PARAM_LABEL_HOUR_MIN_DAY));
	}

	getParamMaxDay(): number {
		return JSON.parse(sessionStorage.getItem(PARAM_LABEL_HOUR_MAX_DAY));
	}

	// getServiceCenterType(): number {
	// 	const user = this.getUser();
	// 	return user?.employee.serviceCenter.type;
	// }

	// getServiceCenter(): ServiceCenter {
	// 	const user = this.getUser();
	// 	return user?.employee.serviceCenter;
	// }

	// isSESSAD(): boolean {
	// 	return this.getServiceCenterType() === 1 ? true : false;
	// }

	// isSAAD(): boolean {
	// 	return this.getServiceCenterType() === 2 ? true : false;
	// }

	// isSSIAD(): boolean {
	// 	return this.getServiceCenterType() === 3 ? true : false;
	// }

	// isHomeCare(): boolean {
	// 	const user = this.getUser();
	// 	return user.employee.serviceCenter.type > 1 ? true : false;
	// 	// return JSON.parse(sessionStorage.getItem(PARAM_HOMECARE)) === 'true' ? true : false;
	// }

	isPreferencesBeneficiaireActive(): boolean {
		if (
			JSON.parse(sessionStorage.getItem(PARAM_PREFERENCES_BENEFICIAIRE)) ===
			'true'
		) {
			return true;
		} else {
			return false;
		}
	}

	getParamAvailabilityPlanningActive(): boolean {
		if (
			JSON.parse(
				sessionStorage.getItem(PARAM_IS_AVAILABILITY_PLANNING_VISIBLE)
			) === 'true'
		) {
			return true;
		} else {
			return false;
		}
	}

	getLabel(paramLabel: string): string {
		return JSON.parse(sessionStorage.getItem(paramLabel));
	}

	getLabelCapitalized(paramLabel: string): string {
		const label = this.getLabel(paramLabel);
		if (label === null) {
			return null;
		}
		return label.charAt(0).toUpperCase() + label.slice(1);
	}

	getLabelPluralized(paramLabel: string): string {
		return this.getLabel(paramLabel) + 's';
	}

	getLabelCapitalizedPluralized(paramLabel: string): string {
		return this.getLabelCapitalized(paramLabel) + 's';
	}

	removeSessionItem(param: string): void {
		sessionStorage.removeItem(param);
	}

	setRefreshNotificationRateInSeconds(rate: number) {
		sessionStorage.setItem(this.NOTIFICATION_REFRESH_RATE_KEY, '' + rate);
	}

	getRefreshNotificationRateInSeconds(): number {
		return +sessionStorage.getItem(this.NOTIFICATION_REFRESH_RATE_KEY);
	}
}
